export const Entidades = {
  SSOCIEDADES: 'Superintendencia de Sociedades',
  DIMAR: 'Dirección General Marítima y Portuaria',
  SFC: 'Superintendencia Financiera',
  DNDA: 'Dirección Nacional de Derechos de Autor',
  SSALUD: 'Superintendencia de Salud',
  SIC: 'Superintendencia de Industria y Comercio',
  ICA: 'Instituto Colombiano Agropecuario',
};
